module.exports = "./img/4c6a1f6f9f4eaed49c07c56d44186562.jpg";